'use client';

import Image from 'next/image';
import { Typography } from '@/components/Typography';
import { breakpointUtils } from '@/lib/breakpoints';
import { cn } from '@/lib/cn';
import { ToggleCompare } from './ToggleCompare';
import { useVehicleCompareState } from './VehicleCompareContext';
import addVehicleDefault from './add_vehicle_default.png';

export function StickyListContent() {
    const { categories } = useVehicleCompareState();

    const { up } = breakpointUtils;
    const sizes = `
      ${up('md')} 80px,
      98px
    `;

    return categories.length > 0
        ? categories.map((category, index) => {
              const categoryKey = category ? `${category.code}-${category.region}` : null;
              const key = `sticky-list-${index}-${categoryKey}`;
              const categoryImage = category?.studioImage || category?.scenicImage;

              return (
                  <div className="flex flex-col md:flex-row items-center justify-center md:justify-between border-1 border-base-300 rounded-lg relative pr-0 md:pr-6" key={key}>
                      <div
                          className={cn(
                              'w-24.5 md:w-20 h-24.5 md:h-20 relative rounded-t-lg md:rounded-t-none md:rounded-l-lg overflow-hidden text-center border-b-1 md:border-b-0 md:border-r-1 border-base-300',
                              {
                                  'bg-(image:--texture-url) bg-center bg-no-repeat bg-cover': !categoryImage,
                              }
                          )}
                          style={!categoryImage ? { '--texture-url': `url(${addVehicleDefault.src})` } : undefined}
                      >
                          {categoryImage ? <Image src={categoryImage} className="aspect-1 object-cover" fill={true} alt={category?.name || ''} sizes={sizes} /> : null}
                      </div>
                      <Typography as="h6" variant="paragraph-heavy" className="flex flex-row items-center justify-between gap-2 p-2 md:pl-6 md:py-4 relative grow text-[14px] md:text-[18px]">
                          {category?.name || 'Add vehicle'}
                      </Typography>
                      {category ? (
                          <div className="absolute md:static -top-2 -right-2">
                              <ToggleCompare fleetCategory={category} variant="icon" />
                          </div>
                      ) : null}
                  </div>
              );
          })
        : null;
}
